import { Pipe, PipeTransform } from '@angular/core';
import { HeatLoadCalculationPartial } from '@nx-customer-apps/api-planning-projects';
import { LodashService } from '@nx-customer-apps/shared/services';

@Pipe({
    name: 'totalHeatload',
    standalone: false
})
export class TotalHeatloadPipe implements PipeTransform {
    transform(calculation: HeatLoadCalculationPartial | null): number | null {
        if (LodashService.isNil(calculation?.baseHeatLoad)) {
            return null;
        }

        return (calculation?.baseHeatLoad || 0) + (calculation?.lockTimeHeatLoad || 0) + (calculation?.warmWaterHeatLoad || 0);
    }
}
